import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { BlobImageDestroyAction, BlobImageLoadAction } from '../../domains/blobImages/actions.types';

import { BlobImages } from './types';

export type BlobImageAction = BlobImageLoadAction | BlobImageDestroyAction;

const initialState: BlobImages = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<BlobImages, BlobImageAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'BLOB_IMAGE.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.image);
    case 'BLOB_IMAGE.LOAD_PENDING':
      return moveToPending(state, [action.payload.image.id]);
    case 'BLOB_IMAGE.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.image.id], action.payload.error);
    case 'BLOB_IMAGE.DESTROY':
      return remove(state, [action.payload.blobImageId]);
    default:
      return state;
  }
};

export default reducer;
